import {StatusType} from 'models/StatusTypes';
import {Text} from 'native-base';
import {useEffect} from 'react';

import PanelContainer from 'components/PanelContainer';
import StatusDisplay from 'components/StatusDisplay';
import {useIsOpenWebView} from 'hooks/useIsOpenWebView';
import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';

const PRSuccess: React.FunctionComponent = () => {
  const hideCloseBtn = useIsOpenWebView();

  const {trackAdobeEvent} = useTrackEvent();
  useEffect(() => {
    trackAdobeEvent({
      event: AdobeEvent.pageLoad,
      page: {
        name: 'password reset update password success',
      },
    });
  }, []);

  return (
    <PanelContainer isDialogBox={false} hideCloseBtn={hideCloseBtn}>
      <StatusDisplay titleText="SUCCESS" statusType={StatusType.SUCCESS}>
        <>
          <Text mb="24px" bold>
            Your password has been reset
          </Text>
          <Text mb="12px">
            Please close this window to return to your Account
          </Text>
        </>
      </StatusDisplay>
    </PanelContainer>
  );
};

export default PRSuccess;
